// Access token: solo en memoria. Refresh token: localStorage (para sobrevivir
// recargas). NOTA de seguridad: httpOnly cookie sería más seguro; el backend v3
// entrega el refresh en el body, así que se persiste en localStorage por ahora.
let accessToken: string | null = null;

const REFRESH_KEY = "isypos_v3_rt";

export function getAccessToken() {
  return accessToken;
}

export function setAccessToken(value: string | null) {
  accessToken = value;
}

export function getRefreshToken(): string | null {
  try {
    return localStorage.getItem(REFRESH_KEY);
  } catch {
    return null;
  }
}

export function setRefreshToken(value: string | null) {
  try {
    if (value) localStorage.setItem(REFRESH_KEY, value);
    else localStorage.removeItem(REFRESH_KEY);
  } catch {
    /* ignore */
  }
}
